/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { EvaluationEvent } from '../models';
import { PushAllEvaluationEventsToHcp } from '../models';
import { QrCodeResponseDto } from '../models';
import { UpdateEvaluationEventDto } from '../models';
/**
 * EvaluationEventsApi - axios parameter creator
 * @export
 */
export const EvaluationEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all Evaluation Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/evaluation-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an Evaluation Event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling evaluationEventControllerFindOne.');
            }
            const localVarPath = `/api/evaluation-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a PDF with the QR code for the form
         * @param {string} id 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerGenerateQrCodePdf: async (id: string, timezone: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling evaluationEventControllerGenerateQrCodePdf.');
            }
            // verify required parameter 'timezone' is not null or undefined
            if (timezone === null || timezone === undefined) {
                throw new RequiredError('timezone','Required parameter timezone was null or undefined when calling evaluationEventControllerGenerateQrCodePdf.');
            }
            const localVarPath = `/api/evaluation-events/{id}/qrcode/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns QR code image for Evaluation Event form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerGetQrCode: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling evaluationEventControllerGetQrCode.');
            }
            const localVarPath = `/api/evaluation-events/{id}/qrcode`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pushes all events for a tenant to HCP.
         * @param {PushAllEvaluationEventsToHcp} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerPushAllEventsToHcp: async (body: PushAllEvaluationEventsToHcp, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling evaluationEventControllerPushAllEventsToHcp.');
            }
            const localVarPath = `/api/evaluation-events/push-all-for-tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refreshes all evaluation event responses based on their start and end dates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerRefreshEvaluationEvents: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/evaluation-events/refresh-all-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh the responses of an Evaluation Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerRefreshResponses: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling evaluationEventControllerRefreshResponses.');
            }
            const localVarPath = `/api/evaluation-events/{id}/refresh-responses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends completion emails for the events that have just ended.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerSendEvaluationEventCompletedEmails: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/evaluation-events/send-completed-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an Evaluation Event
         * @param {UpdateEvaluationEventDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationEventControllerUpdate: async (body: UpdateEvaluationEventDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling evaluationEventControllerUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling evaluationEventControllerUpdate.');
            }
            const localVarPath = `/api/evaluation-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvaluationEventsApi - functional programming interface
 * @export
 */
export const EvaluationEventsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all Evaluation Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<EvaluationEvent>>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerFindAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get an Evaluation Event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EvaluationEvent>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerFindOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Download a PDF with the QR code for the form
         * @param {string} id 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerGenerateQrCodePdf(id: string, timezone: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Blob>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerGenerateQrCodePdf(id, timezone, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns QR code image for Evaluation Event form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerGetQrCode(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<QrCodeResponseDto>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerGetQrCode(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Pushes all events for a tenant to HCP.
         * @param {PushAllEvaluationEventsToHcp} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerPushAllEventsToHcp(body: PushAllEvaluationEventsToHcp, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerPushAllEventsToHcp(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Refreshes all evaluation event responses based on their start and end dates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerRefreshEvaluationEvents(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerRefreshEvaluationEvents(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Refresh the responses of an Evaluation Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerRefreshResponses(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerRefreshResponses(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Sends completion emails for the events that have just ended.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerSendEvaluationEventCompletedEmails(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerSendEvaluationEventCompletedEmails(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an Evaluation Event
         * @param {UpdateEvaluationEventDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerUpdate(body: UpdateEvaluationEventDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EvaluationEvent>>> {
            const localVarAxiosArgs = await EvaluationEventsApiAxiosParamCreator(configuration).evaluationEventControllerUpdate(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EvaluationEventsApi - factory interface
 * @export
 */
export const EvaluationEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get all Evaluation Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerFindAll(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<EvaluationEvent>>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an Evaluation Event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<EvaluationEvent>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a PDF with the QR code for the form
         * @param {string} id 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerGenerateQrCodePdf(id: string, timezone: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Blob>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerGenerateQrCodePdf(id, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns QR code image for Evaluation Event form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerGetQrCode(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<QrCodeResponseDto>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerGetQrCode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pushes all events for a tenant to HCP.
         * @param {PushAllEvaluationEventsToHcp} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerPushAllEventsToHcp(body: PushAllEvaluationEventsToHcp, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerPushAllEventsToHcp(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refreshes all evaluation event responses based on their start and end dates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerRefreshEvaluationEvents(options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerRefreshEvaluationEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh the responses of an Evaluation Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerRefreshResponses(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerRefreshResponses(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends completion emails for the events that have just ended.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerSendEvaluationEventCompletedEmails(options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerSendEvaluationEventCompletedEmails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an Evaluation Event
         * @param {UpdateEvaluationEventDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationEventControllerUpdate(body: UpdateEvaluationEventDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<EvaluationEvent>> {
            return EvaluationEventsApiFp(configuration).evaluationEventControllerUpdate(body, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EvaluationEventsApi - object-oriented interface
 * @export
 * @class EvaluationEventsApi
 * @extends {BaseAPI}
 */
export class EvaluationEventsApi extends BaseAPI {
    /**
     * 
     * @summary Get all Evaluation Events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerFindAll(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<EvaluationEvent>>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get an Evaluation Event by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerFindOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<EvaluationEvent>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Download a PDF with the QR code for the form
     * @param {string} id 
     * @param {string} timezone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerGenerateQrCodePdf(id: string, timezone: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Blob>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerGenerateQrCodePdf(id, timezone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns QR code image for Evaluation Event form
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerGetQrCode(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<QrCodeResponseDto>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerGetQrCode(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Pushes all events for a tenant to HCP.
     * @param {PushAllEvaluationEventsToHcp} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerPushAllEventsToHcp(body: PushAllEvaluationEventsToHcp, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerPushAllEventsToHcp(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Refreshes all evaluation event responses based on their start and end dates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerRefreshEvaluationEvents(options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerRefreshEvaluationEvents(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Refresh the responses of an Evaluation Event
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerRefreshResponses(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerRefreshResponses(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Sends completion emails for the events that have just ended.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerSendEvaluationEventCompletedEmails(options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerSendEvaluationEventCompletedEmails(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Update an Evaluation Event
     * @param {UpdateEvaluationEventDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationEventsApi
     */
    public async evaluationEventControllerUpdate(body: UpdateEvaluationEventDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<EvaluationEvent>> {
        return EvaluationEventsApiFp(this.configuration).evaluationEventControllerUpdate(body, id, options).then((request) => request(this.axios, this.basePath));
    }
}
